"use client";
import { jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { ConsentManagementErrorDrawer } from "../ConsentManagementErrorDrawer/index.js";
import { useConsentManager } from "../../../hooks/useConsentManager/index.js";
const elementId = "costco-consent-manager";
const Portal = ({
  children
}) => {
  const portalRoot = document.getElementById(elementId);
  if (!portalRoot) {
    console.error(`Portal root '${elementId}' not found`);
    return null;
  }
  return ReactDOM.createPortal(children, portalRoot);
};
const ConsentManagementPortal = (props) => {
  const {
    state: { isErrorDrawerOpen }
  } = useConsentManager();
  if (!isErrorDrawerOpen) {
    return null;
  }
  return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(ConsentManagementErrorDrawer, { ...props }) });
};
export {
  ConsentManagementPortal
};
